// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';
import CloseIcon from '../../../assets/images/X.svg';

export const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;

    height: calc(100vh - 70px - 90px);
    overflow: scroll;

    padding: 33px 19px 32px 32px;
  `,
  Title: styled.div`
    font-weight: 700;
    font-size: 24px;
    color: #434343;
    margin-bottom: 9px;
  `,
  ConditionsContainer: styled.div`
    padding: 11px 0;
  `,
  Condition: styled.div<{ isSelected: boolean }>`
    width: 227px;
    position: relative;

    display: flex;
    justify-content: space-between;

    padding: 6px 9px;
    margin-bottom: 4px;

    border-radius: 4px;
    background-color: ${props => props.isSelected ? '#FFD163' : '#FFF'};
    cursor: pointer;

    @media only screen and (max-width: 1024px) {
      width: 154px;
    }

    &:hover {
      background-color: rgba(255, 209, 99, 0.7)
    }
  `,
  ConditionTitle: styled.div`
    font: 16px Noto Sans TC;
    color: #434343;
    margin-right: 12px;
  `,
  ConditionCancelButton: styled.img.attrs({ src: CloseIcon, alt: 'close-icon' })`
    cursor: pointer;
    position: absolute;
    right: 12px;
    top: 12px;
  `,
};
